/**
 * Seek Key Account Widget v3
 * Header: avatar (logado) ou "Entrar" (nao logado)
 * Dropdown: avatar blur header + colored icons
 * SECURITY: all user data (avatar_url, name, email) escaped via esc() before innerHTML
 */
(function() {
    'use strict';
    var PORTAL = 'https://secure.seekkey.com.br';
    var SELECTOR = 'a.header__icon--account';

    function getCookie(name) {
        var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
        return m ? m[1] : null;
    }
    function setCookie(name, value, days) {
        var expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = name + '=' + value + '; domain=.seekkey.com.br; path=/; expires=' + expires + '; SameSite=Lax; Secure';
    }
    function getCustomer() {
        var raw = getCookie('sk_customer');
        if (!raw) return null;
        try { return JSON.parse(decodeURIComponent(raw)); } catch(e) { return null; }
    }
    /** Escapes HTML special chars to prevent XSS */
    function esc(s) {
        return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    function getInitials(name) {
        return (name || '').split(' ').map(function(w) { return w[0] || ''; }).slice(0, 2).join('').toUpperCase() || '?';
    }

    // Static SVG icon templates (no user input) — same color as text
    var ICONS = {
        games: '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>',
        heart: '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>',
        orders: '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>',
        account: '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>',
        logout: '<svg width="18" height="18" viewBox="0 0 24 24" fill="#FF7070"><path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>',
        login: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>',
    };

    function setup(link, customer) {
        if (!customer) {
            link.setAttribute('href', PORTAL + '/conta/login');
            while (link.firstChild) link.removeChild(link.firstChild);
            var iconSpan = document.createElement('span');
            iconSpan.className = 'sk-w-login-icon';
            // Static SVG, no user data
            iconSpan.innerHTML = ICONS.login;
            link.appendChild(iconSpan);
            var textSpan = document.createElement('span');
            textSpan.className = 'sk-w-login-text';
            textSpan.textContent = 'Entrar';
            link.appendChild(textSpan);
            link.classList.add('sk-w-login-btn');
            return;
        }

        // Logged in: show avatar in header
        link.removeAttribute('href');
        link.style.cursor = 'pointer';
        link.setAttribute('title', 'Minha Conta');
        link.classList.add('sk-w-avatar-wrap');

        // All user data escaped via esc()
        var avatarUrl = customer.avatar_url ? esc(customer.avatar_url) : '';
        var initials = esc(getInitials(customer.name));
        var firstName = esc(customer.name ? customer.name.split(' ')[0] : '');
        var email = esc(customer.email);

        var avatarContent = avatarUrl
            ? '<img src="' + avatarUrl + '" class="sk-w-avatar-img" alt="">'
            : '<span class="sk-w-avatar-initials">' + initials + '</span>';
        // Static HTML structure + escaped user data only
        link.innerHTML = '<div class="sk-w-avatar">' + avatarContent + '</div>';

        // Build dropdown
        var dd = document.createElement('div');
        dd.id = 'sk-account-dropdown';

        // Hero background: blurred avatar image or gradient fallback
        var headerBg = avatarUrl
            ? '<div class="sk-dd-bg"><img src="' + avatarUrl + '" alt=""></div>'
            : '<div class="sk-dd-bg sk-dd-bg-gradient"></div>';

        var headerAvatar = avatarUrl
            ? '<img src="' + avatarUrl + '" class="sk-dd-avatar-img" alt="">'
            : '<span class="sk-dd-avatar-init">' + initials + '</span>';

        // All innerHTML below uses only: escaped user data + static SVG/HTML templates
        dd.innerHTML =
            '<div class="sk-dd-hero">' +
                headerBg +
                '<div class="sk-dd-hero-content">' +
                    '<div class="sk-dd-avatar">' + headerAvatar + '</div>' +
                    '<div class="sk-dd-info">' +
                        '<div class="sk-dd-nm">Ol\u00e1, ' + firstName + '!</div>' +
                        '<div class="sk-dd-em">' + email + '</div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            '<div class="sk-dd-menu">' +
                '<a href="' + PORTAL + '/conta/jogos" class="sk-dd-a"><span class="sk-dd-ic">' + ICONS.games + '</span>Meus Games</a>' +
                '<a href="' + PORTAL + '/conta/wishlist" class="sk-dd-a"><span class="sk-dd-ic">' + ICONS.heart + '</span>Lista de Desejos</a>' +
                '<a href="' + PORTAL + '/conta/pedidos" class="sk-dd-a"><span class="sk-dd-ic">' + ICONS.orders + '</span>Meus Pedidos</a>' +
                '<a href="' + PORTAL + '/conta/perfil" class="sk-dd-a"><span class="sk-dd-ic">' + ICONS.account + '</span>Minha Conta</a>' +
            '</div>' +
            '<div class="sk-dd-foot">' +
                '<button class="sk-dd-a sk-dd-x" onclick="window.skLogout()"><span class="sk-dd-ic">' + ICONS.logout + '</span>Sair</button>' +
            '</div>';
        document.body.appendChild(dd);

        function pos() {
            var r = link.getBoundingClientRect();
            dd.style.top = (r.bottom + window.scrollY + 10) + 'px';
            dd.style.right = Math.max(12, document.documentElement.clientWidth - r.right) + 'px';
        }

        link.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var isOpen = dd.classList.contains('sk-dd-show');
            dd.classList.toggle('sk-dd-show', !isOpen);
            if (!isOpen) pos();
        });

        document.addEventListener('click', function(e) {
            if (!dd.contains(e.target) && !link.contains(e.target)) {
                dd.classList.remove('sk-dd-show');
            }
        });
        window.addEventListener('scroll', function() {
            if (dd.classList.contains('sk-dd-show')) pos();
        }, { passive: true });
    }

    window.skLogout = function() {
        document.cookie = 'sk_token=; domain=.seekkey.com.br; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure';
        document.cookie = 'sk_customer=; domain=.seekkey.com.br; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure';
        fetch(PORTAL + '/api/conta/logout', { method: 'POST', credentials: 'include' }).catch(function(){});
        window.location.reload();
    };

    function css() {
        var s = document.createElement('style');
        s.textContent =
            /* Hide original Shopify account icon */
            'a.header__icon--account>account-icon,a.header__icon--account>.svg-wrapper,a.header__icon--account>.not-mobile-true-desk-flex,a.header__icon--account>.visually-hidden{display:none!important}' +
            'a.header__icon--account{order:3!important}a.header__icon--cart{order:2!important}' +

            /* Avatar in header */
            '.sk-w-avatar-wrap{display:flex!important;align-items:center!important;text-decoration:none!important}' +
            '.sk-w-avatar{width:40px;height:40px;border-radius:50%;overflow:hidden;border:2px solid rgba(255,255,255,.12);flex-shrink:0;display:flex;align-items:center;justify-content:center;background:#161940;transition:border-color .2s ease}' +
            '.sk-w-avatar:hover{border-color:rgba(255,255,255,.3)}' +
            '.sk-w-avatar-img{width:100%;height:100%;object-fit:cover;display:block;border-radius:50%}' +
            '.sk-w-avatar-initials{color:#8B8FAD;font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:.5px}' +

            /* Login button */
            '.sk-w-login-btn{display:flex!important;align-items:center!important;gap:6px!important;text-decoration:none!important;color:#fff!important;font-size:14px!important;font-weight:500!important;transition:opacity .2s!important}' +
            '.sk-w-login-btn:hover{opacity:.8!important}' +
            '.sk-w-login-icon{display:flex;align-items:center}' +
            '.sk-w-login-text{font-family:"Poppins",system-ui,sans-serif}' +
            '@media(max-width:990px){.sk-w-login-text{display:none!important}.sk-w-login-btn{padding:0!important;margin:0!important}}' +

            /* Dropdown container */
            '#sk-account-dropdown{display:none;position:absolute;width:290px;background:linear-gradient(180deg,#0E1235 0%,#080A22 100%);border:1px solid rgba(255,255,255,.08);border-radius:18px;box-shadow:0 20px 60px rgba(0,0,0,.8),0 0 0 1px rgba(255,255,255,.04);z-index:999999;overflow:hidden;font-family:"Poppins",system-ui,sans-serif}' +
            '#sk-account-dropdown.sk-dd-show{display:block;animation:skDdIn .25s cubic-bezier(.16,1,.3,1)}' +
            '@keyframes skDdIn{from{opacity:0;transform:translateY(-10px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}' +

            /* Hero header with blur background */
            '.sk-dd-hero{position:relative;overflow:hidden;padding:20px 20px 16px;min-height:80px}' +
            '.sk-dd-bg{position:absolute;top:0;left:0;right:0;bottom:0;z-index:0}' +
            '.sk-dd-bg img{width:100%;height:100%;object-fit:cover;filter:blur(20px) brightness(.4) saturate(1.4);transform:scale(1.3)}' +
            '.sk-dd-bg::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(14,18,53,.3) 0%,rgba(14,18,53,.85) 100%)}' +
            '.sk-dd-bg-gradient{background:linear-gradient(135deg,#1a1050 0%,#0a0d2a 50%,#12153a 100%)}' +
            '.sk-dd-bg-gradient::after{content:none}' +
            '.sk-dd-hero-content{position:relative;z-index:1;display:flex;align-items:center;gap:14px}' +
            '.sk-dd-avatar{width:48px;height:48px;border-radius:50%;overflow:hidden;border:2px solid rgba(255,255,255,.2);flex-shrink:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.08)}' +
            '.sk-dd-avatar-img{width:100%;height:100%;object-fit:cover;border-radius:50%}' +
            '.sk-dd-avatar-init{color:rgba(255,255,255,.7);font-size:16px;font-weight:700;text-transform:uppercase;letter-spacing:1px}' +
            '.sk-dd-info{flex:1;min-width:0}' +
            '.sk-dd-nm{color:#fff;font-size:15px;font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
            '.sk-dd-em{color:rgba(255,255,255,.5);font-size:11.5px;margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +

            /* Menu items */
            '.sk-dd-menu{padding:6px 0}' +
            '.sk-dd-a{display:flex;align-items:center;gap:12px;padding:11px 20px;color:rgba(255,255,255,.85);font-size:13.5px;font-weight:500;text-decoration:none;transition:all .15s;border:none;background:none;width:100%;cursor:pointer;font-family:inherit;text-align:left}' +
            '.sk-dd-a:hover{background:rgba(255,255,255,.06);color:#fff}' +
            '.sk-dd-ic{display:flex;align-items:center;justify-content:center;width:20px;height:20px;flex-shrink:0}' +
            '.sk-dd-ic svg{opacity:.85;transition:opacity .15s}' +
            '.sk-dd-a:hover .sk-dd-ic svg{opacity:1}' +

            /* Footer / Logout */
            '.sk-dd-foot{border-top:1px solid rgba(255,255,255,.06);padding:2px 0}' +
            '.sk-dd-x{color:#FF7070!important}' +
            '.sk-dd-x:hover{background:rgba(255,107,107,.08)!important}';
        document.head.appendChild(s);
    }

    function resolveCustomer(callback) {
        var customer = getCustomer();
        if (customer) return callback(customer);
        fetch(PORTAL + '/api/conta/me', { credentials: 'include' })
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(function(data) {
                if (data && data.loggedIn && data.customer) {
                    setCookie('sk_customer', encodeURIComponent(JSON.stringify(data.customer)), 7);
                    callback(data.customer);
                } else {
                    callback(null);
                }
            })
            .catch(function() { callback(null); });
    }

    function waitForElement() {
        var el = document.querySelector(SELECTOR);
        if (el) { resolveCustomer(function(c) { setup(el, c); }); return; }
        var attempts = 0;
        var obs = new MutationObserver(function() {
            var el = document.querySelector(SELECTOR);
            if (el) { obs.disconnect(); resolveCustomer(function(c) { setup(el, c); }); return; }
            attempts++;
            if (attempts > 100) obs.disconnect();
        });
        obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
        var iv = setInterval(function() {
            var el = document.querySelector(SELECTOR);
            if (el) { clearInterval(iv); resolveCustomer(function(c) { setup(el, c); }); }
        }, 200);
        setTimeout(function() { clearInterval(iv); }, 10000);
    }

    function start() { css(); waitForElement(); }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
    } else {
        start();
    }
})();
